import { useTranslations } from "next-intl";

// 维护中
export default function Maintenance() {
  const t = useTranslations('home');
  return (
    <div className="pointer-events-none absolute top-0 left-0 text-ss leading-4 px-3 text-center text-secondary font-medium w-full h-full flex items-center justify-center bg-dark/80 rounded-[10px]">
      {t('maintenance')}
    </div>
  );
}